import { useActiveStoreCatalog } from '../../store/selectors/menu';
import { store } from '../../index';
import React, { Fragment } from "react"; // aligned back button styling
import { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Grid, Typography, Button, TextField, IconButton } from "@material-ui/core";
import ChevronLeftTwoToneIcon from "@mui/icons-material/ChevronLeftTwoTone";
import ClearIcon from "@mui/icons-material/Clear";
import Drawer from "@mui/material/Drawer";
import AddIcon from "@mui/icons-material/Add";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useNavigate, useLocation } from "react-router-dom";
import FSROrders from "./FSR-Orders";
import { getFSRFlow, getFSRTableId, stripTablePrefix, getFSRTableCacheKey } from '../../utils/fsr_helper';

import Navbar from "../../components/Navbar";
import ItemModifier from "../../components/Modifier";
import {
  addToCart,
  removeItem,
  addQuantity,
  subtractQuantity,
  showCart,
  specialRequest,
  updateItemSpecialRequest,
  clearCart,
} from "../../store/actions/cartActions";
import { set_customer, clear_applied_offer, order_place, set_last_order } from "../../store/actions/action";
import { create_order, placeOrder } from "../../utils/order_helper";
import { get_customer_list } from "../../utils/customer_helper";

import { BUTTON_COLOR, STORE_FB, TEXT_COLOR, TOKEN_KEY } from "../../utils/constant";
import CartItems from "./CartItems";
import CartAmount from "./CartAmount";
import { getFSRTableDisplayName } from "../../utils/fsr_helper";
import ExtraItems from "../../components/ExtraItems";
import CartOffers from "./CartOffers";
import { get_inventory, get_food_inventory, check_inventory_stock, update_local_storage_stock, remove_out_of_stock_from_cart } from "../../utils/item_helper";
import AddressPopup from "../login/AddressPopup";
import CartAddress from "./CartAddress";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import DesktopCartView from "./DesktopCartView";
import useIsDesktop from "../../hooks/useIsDesktop";

const Cart = function (props) {
  const { cartProps, reducer, customerReducer } = props;
  const { addedItems } = cartProps;
  const isDesktop = useIsDesktop();
  const sessionReducer = useSelector(state => state.sessionReducer) || {};
  const { is_fsr } = sessionReducer;
  const businessDate = sessionReducer?.store_details?.business_date;

  const getFSRStatus = () => is_fsr === true;
  // Direct table_id comparison — table_details comes from the API and is stored as-is in Redux.
  const isCurrentFSRTableOrder = (order) => {
    const sessionTableId = getFSRFlow()?.table_id;
    const orderTableId = order?.store_details?.table_id || order?.table_id;
    if (sessionTableId && orderTableId) return String(sessionTableId) === String(orderTableId);
    // Fallback: compare table_no
    const sessionTableNo = stripTablePrefix(getFSRFlow()?.table_no || "");
    const orderTableNo = stripTablePrefix(order?.store_details?.table_no || order?.table_no || "");
    return sessionTableNo && sessionTableNo === orderTableNo;
  };
  const isSameFSRFloorAndTable = isCurrentFSRTableOrder;
  const { customer } = reducer;
  const storeOffer = cartProps?.storeOffer;
  const storeInfo = sessionReducer?.store_details || sessionReducer?.store_details || {};
  const storeInfoConfig = sessionReducer?.store_config || sessionReducer?.store_config || {};
  const type = cartProps?.orderType?.order?.order_type || "Takeaway";
  const orderCode = cartProps?.orderType?.order?.order_code || cartProps?.orderType?.order?.channel_code;
  const isDelivery = (type || "").trim().toLowerCase() === "delivery" || (orderCode || "").trim().toLowerCase() === "del";
  const selectedAddressText = customer?.cust_address || (customer?.address?.length ? customer.address[0]?.cust_address : "");
  const navigate = useNavigate();
  const { items: catalogItems } = useActiveStoreCatalog();

  const location = useLocation();
  const [specialInst, setSpecialInst] = useState(false);
  const [specialInstText, setSpecialInstText] = useState(null);
  //   const [open, setOpen] = useState(false);
  const [isReload, setIsReload] = useState(true);
  const [allitem, setAllitem] = useState([]);
  const [itemVerriantList, setItemVerriantList] = useState([]);
  const [modifierPopup, setModifierPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [inventoryData, setInventoryData] = useState([]);
  const [arr, setArr] = useState([]);
  const [openInventory, setOpenInventory] = useState(false);
  const [openUserAddInfo, setOpenUserAddInfo] = useState(false);
  const [openUserInfo, setOpenUserInfo] = useState(false);
  const [openOutOfStock, setOpenOutOfStock] = useState(false);
  const [outOfStockItems, setOutOfStockItems] = useState([]);
  const [showConfirmedPopup, setShowConfirmedPopup] = useState(false);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorTitle, setErrorTitle] = useState("Unable to Place Order");


  const getTableNumber = () => {
    const table = getFSRFlow();
    return stripTablePrefix(table?.table_no || table?.table_name || "");
  };

  const extractTableNumber = () => getFSRTableDisplayName();

  let primaryColor = storeInfoConfig?.general_config?.primary_color || "#272727";
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;

  let storeCurrency = storeInfo?.store_currency;
  const [currency, setCurrency] = useState(() => {
    switch (storeCurrency) {
      case "INR":
        return "₹";
      case "USD":
        return "$";
      case "CAD":
        return "$";
      case "OMR":
        return "OMR ";
      case "AED":
        return "AED ";
      default:
        return "$"; // default to dollar if no match
    }
  });

  let storeType = storeInfo?.store_industry;

  let checkInventory = storeInfoConfig?.general_config?.is_inventory_count;

  const handleChange = (e) => {
  	setSpecialInstText(e.target.value);
  };

  const onloadData = async () => {
    const StoreItems = catalogItems || [];
    let filered = StoreItems?.filter((e) => e?.tag[0] === "Best");
    const allItemVerriant = reducer?.item_verriants || [];
    setAllitem(filered);
    setItemVerriantList(allItemVerriant);
    setIsReload(!StoreItems?.length);
  };

  let foodItem = [];

  // Add main items to foodItem array
  addedItems.forEach((e) => {
    if (e.is_void || e.isVoid || e.is_refund) return;
    foodItem.push({
      item_sku: e.sku,
      variant_sku: e.item_variant[0]?.sku,
      quantity: e.quantity,
    });

    // Add selected addon items to foodItem array
    if (e.selected_addons_items?.length) {
      e.selected_addons_items.forEach((addon) => {
        foodItem.push({
          item_sku: addon.sku,
          variant_sku: addon.item_variant[0]?.sku,
          quantity: e.quantity, // Use parent item quantity
        });
      });
    }
  });

  const loadInventory = async () => {
    if (storeType === "F&B") {
      if (!foodItem.length) return;
      await get_food_inventory({ order: foodItem });
    } else {
      const inventory = await get_inventory();
      setInventoryData(inventory);
    }
  };

  useEffect(() => {
    // Auto-scroll to top when navigating to /cart (e.g. from checkout)
    window.scrollTo(0, 0);
    const container = document.getElementById("cart-scroll-container");
    if (container) {
      container.scrollTop = 0;
    }

    if (cartProps?.comment) {
      setSpecialInstText(cartProps?.comment);
    }
    onloadData();

    const isTableMgmt = getFSRStatus();
    const isFSRView = isTableMgmt && location.state?.fsrView === "orders";
    if (isFSRView) return;
    if (addedItems.length === 0) return;
    loadInventory();
  }, [props.reducer, props.cartProps, location.state, storeInfoConfig]);

  useEffect(() => {
    const isFSRView = getFSRStatus() && location.state?.fsrView === "orders";
    if (addedItems.length === 0 && !isFSRView) {
      props.clear_applied_offer();
      navigate("/menu");
    }
  }, [addedItems.length, navigate, location.state, storeInfoConfig]);

  const checkInventoryItem1 = (inventoryDataList) => {
    let resultArr = [];
    for (let i = 0; i < addedItems.length; i++) {
      const checkQuantity = inventoryDataList?.filter(
        (e) => e.sku === addedItems[i]?.item_variant[0]?.sku
      );
      if (
        checkQuantity[0]?.inventory_quantity >= addedItems[i]?.quantity &&
        checkQuantity[0]?.inventory_quantity > 5
      ) {
      } else {
        resultArr.push(addedItems[i]);
      }
    }

    return resultArr;
  };

  const checkInventoryFoodItem1 = (inventoryDataList) => {
    let resultArr = [];

    for (let i = 0; i < addedItems.length; i++) {
      const item = addedItems[i];

      // Check main item availability
      const checkQuantity = inventoryDataList?.find(
        (e) => e.variant_sku === item?.item_variant[0]?.sku
      );

      if (
        checkQuantity?.inventory_availability === true &&
        checkQuantity?.item_availability === false
      ) {
        resultArr.push(item);
      }

      // Check addon items availability
      if (item.selected_addons_items?.length) {
        for (let j = 0; j < item.selected_addons_items.length; j++) {
          const addon = item.selected_addons_items[j];
          const checkAddonQuantity = inventoryDataList?.find(
            (e) => e.variant_sku === addon?.item_variant[0]?.sku
          );

          if (
            checkAddonQuantity?.inventory_availability === true &&
            checkAddonQuantity?.item_availability === false
          ) {
            // Add the main item to result if any of its addons are unavailable
            if (!resultArr.includes(item)) {
              resultArr.push(item);
            }
          }
        }
      }
    }

    return resultArr;
  };

  const checkyItem = async () => {
    let inventoryData1;
    let foodInventory;
    let result1;

    try {
      if (storeType === STORE_FB) {
        foodInventory = await get_food_inventory({ order: foodItem });
        result1 = checkInventoryFoodItem1(foodInventory);
        setArr(result1);
      } else {
        inventoryData1 = await get_inventory();
        result1 = checkInventoryItem1(inventoryData1);
        setArr(result1);
      }

      if (result1?.length >= 1) {
        setOpenInventory(true);
        setIsPlacingOrder(false);
      } else {
        if (getFSRStatus()) {
          handleFSRCheckout();
        } else {
          type?.toLowerCase() === "delivery"
            ? (customer && Object.keys(customer).length === 0) || customer.guest
              ? setOpenUserInfo(true)
              : setOpenUserAddInfo(true)
            : navigate("/checkout");
          setIsPlacingOrder(false);
        }
      }
    } catch (err) {
      console.error("Error in checkyItem:", err);
      setIsPlacingOrder(false);
    }
  };

  const refreshFSROrders = async () => {
    if (customer?.cust_mobile) {
      try {
        const resp = await get_customer_list({
          cust_mobile: customer?.cust_mobile,
        });
        if (resp) {
          props.set_last_order(resp);
        }
      } catch (err) {
        console.error("Error refreshing FSR orders:", err);
      }
    }
  };

  const handleFSRCheckout = async () => {
    const rawVal = storeInfoConfig?.web_ordering_setting?.is_customer_screen_qr;
    const skipCustomerScreen = rawVal === false || rawVal === "false" || rawVal === "No";
    const isLoggedIn = customer?.cust_mobile && customer?.guest !== "Guest";
    if (!isLoggedIn && !skipCustomerScreen) {
      setOpenUserInfo(true);
      setIsPlacingOrder(false);
      return;
    }
    setIsPlacingOrder(true);
    try {
      const tableNo = getFSRTableCacheKey();
      const activeTableOrder = store.getState().customerReducer.active_table_orders[tableNo];
      const activeOrder = activeTableOrder?.order || null;

      let resp = await placeOrder({
        flow: "FSR_KOT",
        activeOrder
      });

      // ── 400: backend rejected with a specific error message ──────────────────────
      // First check: stale closed order (another device closed it) → clear & retry fresh
      if (resp?._httpStatus === 400 && resp?.message === "Order is already closed and cannot be modified.") {
        store.dispatch({ type: "CLEAR_ACTIVE_TABLE_ORDER", payload: { tableNo } });
        resp = await placeOrder({ flow: "FSR_KOT", activeOrder: null });
      }

      // Second check: if still a 400 after retry (or any other 400), clear cart + refresh
      if (resp?._httpStatus === 400) {
        props.clearCart();
        await refreshFSROrders();
        setErrorTitle("Order could not be placed");
        setErrorMessage(resp?.message || "Something went wrong. Please try again.");
        setOpenErrorPopup(true);
        return;
      }

      if (resp?.status) {
        await refreshFSROrders();
        setShowConfirmedPopup(true);
        setTimeout(() => {
          props.clearCart();
          navigate("/menu");
        }, 4000);
      } else {
        setErrorTitle(resp?.message || "Unable to place order");
        setErrorMessage(resp?.message || "Something went wrong. Please try again.");
        setOpenErrorPopup(true);
      }
    } catch (error) {
      console.error("FSR order placement error:", error);
      setErrorMessage("An error occurred. Please try again.");
      setOpenErrorPopup(true);
    } finally {
      setIsPlacingOrder(false);
    }
  };

  const handleCheckout = async () => {
    if (isPlacingOrder) return;
    setIsPlacingOrder(true);
    try {
      const response = await check_inventory_stock({ items: addedItems });
      if (response && response.status === false) {
        update_local_storage_stock(response.out_of_stock_items || [], catalogItems, props.update_item_list);
        setOutOfStockItems(response.out_of_stock_items || []);
        setOpenOutOfStock(true);
        setIsPlacingOrder(false);
        return;
      }
    } catch (error) {
      console.error("Error checking inventory stock:", error);
    }

    if (checkInventory) {
      loadInventory();
      checkyItem();
    } else {
      if (getFSRStatus()) {
        handleFSRCheckout();
      } else {
        isDelivery
          ? !customer || (customer && Object.keys(customer).length === 0) || customer?.guest
            ? setOpenUserInfo(true)
            : setOpenUserAddInfo(true)
          : navigate("/checkout");
        setIsPlacingOrder(false);
      }
    }
  };

  const isTableMgmt = getFSRStatus();
  const showFSRView = isTableMgmt && location.state?.fsrView === "orders";

  if (showFSRView) {
    return <FSROrders {...props} />;
  }

  return (
    <>
      <Grid style={{ backgroundColor: "white", minHeight: "100vh" }}>
        <Navbar cart cartPage />
        {addedItems?.length === 0 ? (
          <>
            <Grid
              style={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "Satoshi",
                fontSize: "1.8rem",
                marginTop: "60%",
              }}
            >
              <Typography>
                <span
                  style={{
                    fontSize: "1.5rem",
                    fontFamily: "Satoshi",
                  }}
                >
                  Your Cart is Empty !
                </span>
              </Typography>
              <Typography>
                <span
                  style={{
                    fontSize: "1.5rem",
                    fontFamily: "Satoshi",
                  }}
                >
                  Please add item from menu.
                </span>{" "}
              </Typography>

              <div className="PaymentBtn">
                <Button
                  variant="contained"
                  onClick={() => {
                    navigate("/menu");
                  }}
                  style={{
                    fontSize: "1rem",
                    borderRadius: "1rem",
                    minWidth: "100%",
                    padding: "1.1rem",
                    fontWeight: "400",
                    lineHeight1: "1.5",

                    color:  "white"  || TEXT_COLOR,
                    backgroundColor: primaryColor || BUTTON_COLOR,
                  }}
                >
                  Go To menu
                </Button>
              </div>
            </Grid>
          </>
        ) : isDesktop ? (
          <DesktopCartView
            {...props}
            catalogItems={catalogItems}
            allitem={allitem}
            onPlaceOrder={getFSRStatus() ? handleFSRCheckout : handleCheckout}
            addItemToCart={(item) => props.addToCart(item)}
            openUserAddInfo={openUserAddInfo}
            setOpenUserAddInfo={setOpenUserAddInfo}
          />
        ) : (
          <Grid style={{}}>            <Grid
              container
              justifyContent="space-between"
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{
                margin: "0px",
                padding: "10px 4px",
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                borderRadius: "0px",
                boxShadow: "rgba(0, 0, 0, 0.08) 0px 2px 12px",
                boxSizing: "border-box",
                position: "relative"
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <IconButton
                  onClick={() => {
                    navigate("/menu");
                  }}
                  style={{
                    color: "black",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    borderRadius: "8px",
                    padding: "8px"
                  }}
                >
                  <ChevronLeftTwoToneIcon />
                </IconButton>
                <Typography
                  variant="h5"
                  style={{ fontWeight: "bold", marginLeft: "12px" }}
                >
                  Cart
                </Typography>
              </div>

              {(() => {
                const activeColor = primaryColor || "#3159a6";
                const activeBg = activeColor.startsWith("#") && activeColor.length === 7 ? `${activeColor}1A` : "#E3F2FD";
                const tentId = sessionReducer?.tent_id;
                const tableNo = getTableNumber();
                const num = tentId || tableNo || extractTableNumber();
                const tableSuffix = num ? ` (${num})` : "";
                
                let activeOrderTypeName = "Takeaway";
                const code = orderCode || "";
                
                if (getFSRStatus()) {
                  activeOrderTypeName = `Dine In${tableSuffix}`;
                } else if (code === "DI" || code === "di" || (cartProps?.orderType?.order?.order_type || "").toLowerCase().includes("dine")) {
                  activeOrderTypeName = `Dine In${tableSuffix}`;
                } else if (code === "TA" || code === "ta") {
                  activeOrderTypeName = "Takeaway";
                } else if (code === "DEL" || code === "del") {
                  activeOrderTypeName = "Delivery";
                } else {
                  activeOrderTypeName = cartProps?.orderType?.order?.order_type || "Takeaway";
                }

                return (
                  <div
                    style={{
                      position: "absolute",
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: activeBg,
                      color: activeColor,
                      borderRadius: "8px",
                      padding: "6px 16px",
                      fontWeight: "600",
                      fontFamily: "Satoshi",
                      fontSize: "14px",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {activeOrderTypeName}
                  </div>
                );
              })()}
            </Grid>

            <ItemModifier
              style={{ minWidth: "20rem" }}
              {...props}
              {...{
                modifierPopup,
                setModifierPopup,
                selectedItem,
                setSelectedItem,
                allitem,
                itemVerriantList,
                // addonList:"",
                currency,
              }}
            />
            <Grid
              id="cart-scroll-container"
              style={{
                marginTop: "10px",
                backgroundColor: "white",
                display: "flex",
                flexDirection: "column",
                minHeight: "calc(100vh - 90px)",
                justifyContent: "space-between",
                paddingBottom: "260px",
              }}
            >
              <div>
                {/* {localStorage.getItem("CUSTOMER_DATA") === "true" && ( */}

                {!getFSRStatus() && (
                  <CartAddress
                    {...props}
                    {...{
                      openUserInfo,
                      setOpenUserInfo,
                      addedItems,
                      allitem,
                      storeInfoConfig,
                      storeInfo,
                      inventoryData,
                      currency,
                      reducer,
                      arr,
                      setOpenInventory,
                      openInventory,
                    }}
                  />
                )}

                {/* )} */}
                <CartItems
                  {...props}
                  {...{
                    addedItems,
                    allitem,
                    item_list: catalogItems,
                    storeInfoConfig,
                    storeInfo,
                    inventoryData,
                    currency,
                    itemVerriantList,
                    reducer,
                    arr,
                    setOpenInventory,
                    openInventory,
                  }}
                />

                {/* + Add More Items Button */}
                <Grid
                  container
                  style={{
                    paddingRight: "6%",
                    paddingLeft: "4.5%",
                    paddingTop: "0.5rem",
                    paddingBottom: "1rem",
                  }}
                >
                  <Button
                    onClick={() => {
                      navigate("/menu");
                    }}
                    variant="outlined"
                    style={{
                      backgroundColor: "#ffffff",
                      borderColor: primaryColor || BUTTON_COLOR,
                      color: primaryColor || BUTTON_COLOR,
                      borderRadius: "8px",
                      textTransform: "none",
                      fontWeight: "600",
                      fontFamily: "Satoshi",
                      fontSize: "14px",
                      padding: "6px 14px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      boxShadow: "none",
                    }}
                    startIcon={<AddIcon style={{ color: primaryColor || BUTTON_COLOR, fontSize: "20px" }} />}
                  >
                    Add More Items
                  </Button>
                </Grid>
              </div>

              {/* Fixed Bottom Section (Note to Kitchen trigger & CartAmount Card) */}
              <Grid
                style={{
                  backgroundColor: "white",
                  paddingBottom: isTableMgmt ? "260px" : "120px",
                }}
              >
                {/* Note to Kitchen Trigger (only for QSR/non-FSR here) */}
                {!isTableMgmt && (
                  <Grid
                    item
                    onClick={() => {
                      setSpecialInst(true);
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                      padding: "0.8rem 1.3rem",
                    }}
                  >
                    {/* Pencil-on-square SVG icon matching special request icon */}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ flexShrink: 0 }}
                    >
                      <path
                        d="M13.7682 1.962L12.0116 0.22213C11.8606 0.0795438 11.66 0 11.4513 0C11.2427 0 11.0421 0.0795438 10.8911 0.22213L9.32914 1.7739H0.94953C0.697699 1.7739 0.456182 1.87299 0.278111 2.04936C0.100039 2.22573 0 2.46494 0 2.71437V13.0595C0 13.309 0.100039 13.5482 0.278111 13.7245C0.456182 13.9009 0.697699 14 0.94953 14H11.3944C11.6462 14 11.8877 13.9009 12.0658 13.7245C12.2439 13.5482 12.3439 13.0595 12.3439 13.0595V4.48245L13.7682 3.07175C13.9166 2.92451 14 2.72495 14 2.51687C14 2.3088 13.9166 2.10924 13.7682 1.962ZM7.04077 8.41832L5.0515 8.85563L5.52627 6.90416L10.0603 2.40402L11.5938 3.92287L7.04077 8.41832ZM12.1065 3.38681L10.573 1.86795L11.4513 0.998017L12.9848 2.51687L12.1065 3.38681Z"
                        fill={primaryColor || BUTTON_COLOR}
                      />
                    </svg>
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px" }}>
                      <Typography
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "15px",
                          fontWeight: "700",
                          color: primaryColor || BUTTON_COLOR,
                          lineHeight: "1.2",
                        }}
                      >
                        {specialInstText ? "Note to Kitchen:" : "Note to Kitchen"}
                      </Typography>
                      {specialInstText && (
                        <Typography
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "15px",
                            fontWeight: "500",
                            color: "#2C3E50",
                            lineHeight: "1.2",
                          }}
                        >
                          {specialInstText}
                        </Typography>
                      )}
                    </div>
                  </Grid>
                )}

                {/* Note to Kitchen Popup Drawer (Matching Customization Popup Layout) */}
                <Drawer
                  anchor="bottom"
                  open={specialInst}
                  onClose={() => {
                    setSpecialInstText(cartProps?.comment || "");
                    setSpecialInst(false);
                  }}
                  PaperProps={{
                    style: {
                      borderTopLeftRadius: "16px",
                      borderTopRightRadius: "16px",
                      backgroundColor: "#ffffff",
                      overflow: "hidden",
                    },
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      fontFamily: "'Satoshi', sans-serif",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    {/* Header matching Customization Popup */}
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "white",
                        padding: "16px 20px",
                        borderBottom: "1px solid #EDF2F7",
                        boxSizing: "border-box",
                      }}
                    >
                      <Typography
                        style={{
                          fontWeight: 700,
                          fontSize: "18px",
                          fontFamily: "'Satoshi', sans-serif",
                          color: "#2D3748",
                          textAlign: "left",
                        }}
                      >
                        Note to Kitchen
                      </Typography>
                      <CloseRoundedIcon
                        style={{
                          fontSize: "24px",
                          color: primaryColor || BUTTON_COLOR,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSpecialInstText(cartProps?.comment || "");
                          setSpecialInst(false);
                        }}
                      />
                    </Box>

                    {/* Body Content */}
                    <Box
                      style={{
                        width: "100%",
                        padding: "16px",
                        boxSizing: "border-box",
                      }}
                    >
                      {/* Input Field Container */}
                      <Box
                        style={{
                          width: "100%",
                          height: "52px",
                          borderRadius: "8px",
                          border: `1.5px solid ${primaryColor || BUTTON_COLOR}`,
                          backgroundColor: "#ffffff",
                          display: "flex",
                          alignItems: "center",
                          padding: "0 14px",
                          boxSizing: "border-box",
                        }}
                      >
                        <input
                          type="text"
                          className="note-kitchen-input"
                          placeholder="e.g. Dont make it too spicy"
                          value={specialInstText || ""}
                          onChange={handleChange}
                          style={{
                            flex: 1,
                            border: "none",
                            outline: "none",
                            fontSize: "15px",
                            fontWeight: 500,
                            fontFamily: "'Satoshi', sans-serif",
                            color: "#333333",
                            backgroundColor: "transparent",
                            height: "100%",
                          }}
                        />
                        {/* Store Color Pen SVG Icon */}
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ flexShrink: 0, marginLeft: "10px" }}
                        >
                          <path
                            d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z"
                            fill={primaryColor || BUTTON_COLOR}
                          />
                        </svg>
                      </Box>
                    </Box>

                    {/* Bottom Action Footer matching Customization Popup */}
                    <Box
                      sx={{
                        p: 2,
                        borderTop: "1px solid #f0f0f0",
                        bgcolor: "#fff",
                        boxShadow: "0px -2px 10px rgba(0,0,0,0.05)",
                        display: "flex",
                        gap: "12px",
                        boxSizing: "border-box",
                      }}
                    >
                      <Button
                        fullWidth
                        variant="outlined"
                        disableElevation
                        onClick={() => {
                          setSpecialInstText(cartProps?.comment || "");
                          setSpecialInst(false);
                        }}
                        style={{
                          flex: 1,
                          height: "44px",
                          borderRadius: "8px",
                          borderColor: primaryColor || BUTTON_COLOR,
                          color: primaryColor || BUTTON_COLOR,
                          fontWeight: 700,
                          fontSize: "15px",
                          textTransform: "none",
                          fontFamily: "'Satoshi', sans-serif",
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        fullWidth
                        variant="contained"
                        disableElevation
                        onClick={() => {
                          setSpecialInst(false);
                          props.specialRequest(specialInstText);
                        }}
                        style={{
                          flex: 1,
                          height: "44px",
                          borderRadius: "8px",
                          backgroundColor: primaryColor || BUTTON_COLOR,
                          color: "white",
                          fontWeight: 700,
                          fontSize: "15px",
                          textTransform: "none",
                          fontFamily: "'Satoshi', sans-serif",
                          boxShadow: "none",
                        }}
                      >
                        Submit
                      </Button>
                    </Box>
                  </Box>
                </Drawer>

                {!getFSRStatus() && (
                  <CartAmount
                    {...props}
                    {...{
                      cartProps,
                      currency,
                    }}
                  />
                )}
              </Grid>

              {allitem.length ? (
                <Grid
                  style={{
                    marginBottom: !storeOffer?.length ? "5rem" : "2rem",
                  }}
                >
                  {/* <ExtraItems
                  {...props}
                  {...{
                    cartProps,
                    allitem,
                    modifierPopup,
                    setModifierPopup,
                    setSelectedItem,
                    selectedItem,
                    currency,
                    storeInfo,
                  }}
                  /> */}
                </Grid>
              ) : (
                ""
              )}

              {/* <CartOffers
              {...props}
              {...{
                open,
                setOpen,
                currency,
                addedItems,
                storeOffer,
                cartProps,
                storeInfo,
              }}
            /> */}

              <div
                className="PaymentBtn"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                }}
              >
                {isTableMgmt && (
                  <Grid
                    item
                    onClick={() => {
                      setSpecialInst(true);
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                      padding: "8px 0px 12px 0px",
                      width: "100%",
                      borderBottom: "1px solid #f0f0f0",
                      marginBottom: "12px",
                    }}
                  >
                    {/* Pencil-on-square SVG icon matching special request icon */}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ flexShrink: 0 }}
                    >
                      <path
                        d="M13.7682 1.962L12.0116 0.22213C11.8606 0.0795438 11.66 0 11.4513 0C11.2427 0 11.0421 0.0795438 10.8911 0.22213L9.32914 1.7739H0.94953C0.697699 1.7739 0.456182 1.87299 0.278111 2.04936C0.100039 2.22573 0 2.46494 0 2.71437V13.0595C0 13.309 0.100039 13.5482 0.278111 13.7245C0.456182 13.9009 0.697699 14 0.94953 14H11.3944C11.6462 14 11.8877 13.9009 12.0658 13.7245C12.2439 13.5482 12.3439 13.0595 12.3439 13.0595V4.48245L13.7682 3.07175C13.9166 2.92451 14 2.72495 14 2.51687C14 2.3088 13.9166 2.10924 13.7682 1.962ZM7.04077 8.41832L5.0515 8.85563L5.52627 6.90416L10.0603 2.40402L11.5938 3.92287L7.04077 8.41832ZM12.1065 3.38681L10.573 1.86795L11.4513 0.998017L12.9848 2.51687L12.1065 3.38681Z"
                        fill={primaryColor || BUTTON_COLOR}
                      />
                    </svg>
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px" }}>
                      <Typography
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "15px",
                          fontWeight: "700",
                          color: primaryColor || BUTTON_COLOR,
                          lineHeight: "1.2",
                        }}
                      >
                        {specialInstText ? "Note to Kitchen:" : "Note to Kitchen"}
                      </Typography>
                      {specialInstText && (
                        <Typography
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "15px",
                            fontWeight: "500",
                            color: "#2C3E50",
                            lineHeight: "1.2",
                          }}
                        >
                          {specialInstText}
                        </Typography>
                      )}
                    </div>
                  </Grid>
                )}
                <Button
                  variant="contained"
                  disabled={isPlacingOrder || showConfirmedPopup}
                  onClick={() => {
                    handleCheckout();
                  }}
                  style={{
                    fontSize: "1.3rem",
                    borderRadius: "8px",
                    minWidth: "100%",
                    height: "50px",

                    fontWeight: "Bold",
                    color: "white",
                    backgroundColor: primaryColor || BUTTON_COLOR,
                  }}
                >
                  {isPlacingOrder
                    ? "Placing Order..."
                    : getFSRStatus()
                      ? "Place Order"
                      : isDelivery && !selectedAddressText
                        ? "Add Address & pay"
                        : "Send order & pay"}
                </Button>
              </div>
            </Grid>
          </Grid>
        )}
        <AddressPopup
          {...props}
          {...{
            openUserAddInfo,
            setOpenUserAddInfo,
            storeInfo,
            storeInfoConfig,
          }}
          onAddressSelect={() => navigate("/checkout")}
        />
        <Drawer
          open={showConfirmedPopup}
          anchor="bottom"
          onClose={() => {}}
          disableEscapeKeyDown
          ModalProps={{
            keepMounted: true,
            onBackdropClick: (e) => e.stopPropagation(),
          }}
          PaperProps={{
            style: {
              borderTopLeftRadius: "24px",
              borderTopRightRadius: "24px",
              padding: "2rem 1.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "0px -4px 20px rgba(0, 0, 0, 0.08)",
            }
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <svg
              width="80"
              height="78"
              viewBox="0 0 177 173"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.9619 115.211C22.9714 122.409 25.835 129.309 30.9247 134.399C36.0144 139.489 42.9148 142.352 50.1127 142.362H126.474C133.672 142.352 140.572 139.489 145.662 134.399C150.752 129.309 153.615 122.409 153.625 115.211V72.5505H22.9619V115.211Z"
                fill={primaryColor || BUTTON_COLOR}
              />

              <path
                d="M0.0530181 75.9444C-0.131714 78.0623 0.16775 80.1946 0.928745 82.1797C1.68974 84.1649 2.89233 85.9509 4.4455 87.4027C5.99867 88.8545 7.86172 89.9339 9.89366 90.5593C11.9256 91.1848 14.0732 91.3398 16.1739 91.0127V72.5505H3.44687C2.54758 72.5532 1.68588 72.9116 1.04998 73.5475C0.414084 74.1834 0.0556675 75.0451 0.0530181 75.9444Z"
                fill={primaryColor || BUTTON_COLOR}
              />

              <path
                d="M173.138 72.5505H160.412V91.013H162.957C164.74 91.0135 166.505 90.6627 168.153 89.9807C169.8 89.2986 171.297 88.2987 172.557 87.038C173.818 85.7773 174.818 84.2806 175.5 82.6333C176.182 80.9861 176.533 79.2206 176.532 77.4377C176.808 75.0475 175.876 72.6059 173.138 72.5505Z"
                fill={primaryColor || BUTTON_COLOR}
              />

              <path
                d="M61.5137 44.9638C60.9767 45.6724 60.739 46.5632 60.8515 47.4451C60.964 48.327 61.4178 49.1296 62.1155 49.6806C62.8132 50.2316 63.6991 50.487 64.583 50.3921C65.467 50.2971 66.2785 49.8594 66.8432 49.1728C69.7412 45.5177 71.2439 40.9506 71.0824 36.2888C70.9208 31.627 69.1056 27.1749 65.9615 23.7291C63.7005 21.2516 62.4984 17.9878 62.6124 14.6356C62.7264 11.2834 64.1473 8.10877 66.5713 5.79052C67.1982 5.16087 67.5532 4.31056 67.5602 3.4221C67.5672 2.53363 67.2256 1.67784 66.6087 1.03842C65.9918 0.399005 65.1488 0.0269292 64.2607 0.00206357C63.3725 -0.0228021 62.51 0.301525 61.8583 0.905425C58.1562 4.44986 55.9889 9.30285 55.8204 14.4254C55.652 19.5479 57.4957 24.5328 60.9569 28.3128C63.0108 30.5707 64.1945 33.4855 64.2965 36.536C64.3985 39.5865 63.4121 42.5738 61.5137 44.9638Z"
                fill={primaryColor || BUTTON_COLOR}
              />

              <path
                d="M86.3465 44.964C85.8095 45.6725 85.5717 46.5633 85.6842 47.4452C85.7968 48.3271 86.2506 49.1297 86.9483 49.6807C87.646 50.2317 88.5319 50.4871 89.4158 50.3922C90.2998 50.2973 91.1113 49.8595 91.676 49.1729C94.574 45.5178 96.0767 40.9507 95.9151 36.2889C95.7536 31.6271 93.9384 27.175 90.7943 23.7293C88.5333 21.2517 87.3312 17.988 87.4452 14.6357C87.5591 11.2835 88.9801 8.1089 91.4041 5.79064C92.0312 5.16103 92.3863 4.31066 92.3934 3.42211C92.4004 2.53355 92.0588 1.67765 91.4418 1.03817C90.8249 0.398687 89.9818 0.026607 89.0935 0.00181164C88.2053 -0.0229837 87.3427 0.301484 86.6911 0.905552C82.989 4.44999 80.8217 9.30297 80.6532 14.4255C80.4847 19.548 82.3285 24.5329 85.7897 28.3129C87.8435 30.5707 89.0272 33.4856 89.1293 36.5361C89.2313 39.5866 88.2449 42.5739 86.3465 44.964Z"
                fill={primaryColor || BUTTON_COLOR}
              />

              <path
                d="M111.178 44.9639C110.641 45.6724 110.403 46.5632 110.515 47.4451C110.628 48.327 111.082 49.1296 111.779 49.6806C112.477 50.2316 113.363 50.487 114.247 50.3921C115.131 50.2972 115.942 49.8594 116.507 49.1728C119.406 45.5181 120.909 40.9512 120.748 36.2894C120.587 31.6276 118.772 27.1753 115.629 23.7292C113.368 21.2516 112.166 17.9878 112.28 14.6356C112.394 11.2834 113.815 8.10878 116.239 5.79053C116.866 5.16095 117.221 4.31053 117.228 3.42188C117.235 2.53323 116.894 1.67722 116.277 1.03768C115.66 0.398127 114.816 0.02604 113.928 0.00131552C113.04 -0.0234089 112.177 0.301202 111.526 0.905439C107.823 4.44988 105.656 9.30287 105.488 14.4254C105.319 19.5479 107.163 24.5328 110.624 28.3128C112.678 30.5711 113.861 33.4861 113.962 36.5366C114.064 39.5871 113.077 42.5742 111.178 44.9639Z"
                fill={primaryColor || BUTTON_COLOR}
              />

              <path
                d="M144.169 166.189H132.413V156.959C132.413 156.059 132.055 155.196 131.419 154.559C130.782 153.923 129.919 153.565 129.019 153.565C128.119 153.565 127.256 153.923 126.619 154.559C125.983 155.196 125.625 156.059 125.625 156.959V166.189H91.6868V156.008C91.6696 155.119 91.3045 154.272 90.6698 153.65C90.0352 153.027 89.1818 152.679 88.2928 152.679C87.4039 152.679 86.5505 153.028 85.9159 153.65C85.2813 154.273 84.9163 155.119 84.8991 156.008V166.189H50.9607V156.008C50.9607 155.108 50.6032 154.244 49.9667 153.608C49.3302 152.971 48.467 152.614 47.5669 152.614C46.6668 152.614 45.8035 152.971 45.1671 153.608C44.5306 154.244 44.173 155.108 44.173 156.008V166.189H32.4172C31.526 166.203 30.6758 166.566 30.0503 167.201C29.4248 167.836 29.0742 168.692 29.0742 169.583C29.0742 170.474 29.4248 171.33 30.0503 171.965C30.6758 172.6 31.526 172.963 32.4172 172.977H144.169C145.057 172.959 145.903 172.593 146.524 171.959C147.146 171.324 147.494 170.471 147.494 169.583C147.494 168.695 147.146 167.842 146.524 167.207C145.903 166.573 145.057 166.207 144.169 166.189Z"
                fill={primaryColor || BUTTON_COLOR}
              />
            </svg>
            <Typography
              style={{
                fontFamily: "Satoshi",
                fontSize: "28px",
                fontWeight: "700",
                color: primaryColor || "#3f59a6",
                marginTop: "12px",
                marginBottom: "12px",
                textAlign: "center"
              }}
            >
              <span style={{fontSize:"24px"}}>
              Order Confirmed!
              </span>
            </Typography>
            <div
              style={{
                backgroundColor: primaryColor && primaryColor.startsWith("#") && primaryColor.length === 7 ? `${primaryColor}1A` : "#eef0f8",
                borderRadius: "12px",
                padding: "16px 24px",
                width: "100%",
                boxSizing: "border-box",
                marginBottom: "16px"
              }}
            >
              <Typography
                style={{
                  fontFamily: "Satoshi",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#4A5568",
                  textAlign: "center",
                  lineHeight: "1.5"
                }}
              >
                Your order has been successfully received and sent directly to the kitchen.
              </Typography>
            </div>
          </div>
        </Drawer>
        <Dialog
          open={openOutOfStock}
          onClose={() => setOpenOutOfStock(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: "20px",
              padding: "20px",
              backgroundColor: "#fff",
            },
          }}
        >
          <DialogTitle
            style={{
              padding: "0px",
              marginBottom: "10px",
            }}
          >
            <Typography
              style={{
                fontFamily: "Plus Jakarta Sans",
                color: primaryColor || "#000",
                fontWeight: "700",
                textAlign: "center",
              }}
            >
              <span style={{ fontSize: "20px" }}>Out of Stock</span>
            </Typography>
          </DialogTitle>

          <DialogContent style={{ padding: "0px", marginBottom: "20px" }}>
            <Typography
              style={{
                fontFamily: "Satoshi",
                fontSize: "14px",
                color: "#333333",
                textAlign: "left",
                fontWeight: "500",
              }}
            >
              Some items or addons in your cart are currently out of stock. We cannot process your order.
            </Typography>
            <div style={{ maxHeight: "200px", overflowY: "auto", marginTop: "15px", border: "1px solid #EDF2F7", borderRadius: "8px" }}>
              {outOfStockItems?.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    padding: "10px 14px",
                    borderBottom: idx === outOfStockItems.length - 1 ? "none" : "1px solid #EDF2F7",
                    fontSize: "14px",
                    color: "#2D3748",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontFamily: "Satoshi"
                  }}
                >
                  <span style={{ fontWeight: "600" }}>{item.item_name}</span>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#718096",
                      backgroundColor: "#EDF2F7",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      textTransform: "capitalize"
                    }}
                  >
                    {item.type}
                  </span>
                </div>
              ))}
            </div>
          </DialogContent>

          <DialogActions style={{ padding: "0px", justifyContent: "center" }}>
            <Button
              onClick={() => {
                remove_out_of_stock_from_cart(outOfStockItems, addedItems, props.removeItem, props.clearCart);
                setOpenOutOfStock(false);
                navigate("/menu", { state: { skipAutoRedirect: true } });
              }}
              variant="contained"
              disableElevation
              style={{
                flex: "1",
                borderRadius: "8px",
                fontSize: "14px",
                color: "white",
                backgroundColor: primaryColor || BUTTON_COLOR,
                textTransform: "none",
                fontWeight: "700",
                padding: "8px",
                boxShadow: "none",
              }}
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openErrorPopup}
          onClose={() => setOpenErrorPopup(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: "20px",
              padding: "20px",
              backgroundColor: "#fff",
            },
          }}
        >
          <DialogTitle
            style={{
              padding: "0px",
              marginBottom: "10px",
            }}
          >
            <Typography
              style={{
                fontFamily: "Plus Jakarta Sans",
                color: primaryColor || "#e74c3c",
                fontWeight: "700",
                textAlign: "center",
              }}
            >
              <span style={{ fontSize: "20px" }}>{errorTitle}</span>
            </Typography>
          </DialogTitle>

          <DialogContent style={{ padding: "0px", marginBottom: "20px" }}>
            <Typography
              style={{
                fontFamily: "Satoshi",
                fontSize: "14px",
                color: "#333333",
                textAlign: "center",
                fontWeight: "500",
                lineHeight: "1.6"
              }}
            >
              {errorMessage}
            </Typography>
          </DialogContent>

          <DialogActions style={{ padding: "0px", justifyContent: "center" }}>
            <Button
              onClick={() => setOpenErrorPopup(false)}
              variant="contained"
              disableElevation
              style={{
                flex: "1",
                borderRadius: "8px",
                fontSize: "14px",
                color: "white",
                backgroundColor: primaryColor || BUTTON_COLOR,
                textTransform: "none",
                fontWeight: "700",
                padding: "8px",
                boxShadow: "none",
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
    reducer: state.customerReducer,
    customerReducer: state.customerReducer,
    sessionReducer: state.sessionReducer,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (items, quantity) => {
      dispatch(addToCart(items, quantity));
    },
    removeItem: (item) => {
      dispatch(removeItem(item));
    },
    addQuantity: (item) => {
      dispatch(addQuantity(item));
    },
    subtractQuantity: (item) => {
      dispatch(subtractQuantity(item));
    },
    showCart: () => {
      dispatch(showCart());
    },
    set_customer: (obj) => {
      dispatch(set_customer(obj));
    },
      specialRequest: (id) => {
        dispatch(specialRequest(id));
      },
      updateItemSpecialRequest: (itemUniqueId, specialRequest) => {
        dispatch(updateItemSpecialRequest(itemUniqueId, specialRequest));
      },
    clear_applied_offer: () => {
      dispatch(clear_applied_offer());
    },
    update_item_list: (items) => {
      dispatch({ type: "ITEM_LIST", item_list: items });
    },
    clearCart: () => {
      dispatch(clearCart());
    },
    order_place: (obj) => {
      dispatch(order_place(obj));
    },
    set_last_order: (obj) => {
      dispatch(set_last_order(obj));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Cart);
